<div class="modal-header">
    <h4 class="modal-title">
        {{ mode === 'user' ? ('CustomizePermissions' | translate) :
        (role ? ('EditRole' | translate) : ('AddNewRole' | translate)) }}
    </h4>
    <div>
        <i class="fe fe-x black-menu" ngbTooltip="{{ 'Close' | translate }}" (click)="activeModal.dismiss()"></i>
    </div>
</div>
<div class="modal-body pb-0">
    <div class="row">
        <form [formGroup]="form" *ngIf="mode === 'role'" novalidate="novalidate">
            <div class="form-group">
                <div class="form-floating">
                    <input class="form-control" formControlName="Name" placeholder=""
                        [ngClass]="{'is-invalid': submitted && f['Name'].invalid, 'is-valid': submitted && f['Name'].valid}">
                    <label class="form-label">
                        {{ 'RoleName' | translate }} <sup class="text-danger fs-6">*</sup>
                    </label>
                </div>
            </div>
        </form>
    </div>
    <div class="row"
        *ngIf="!(httpService.getLoading('permissionsLoader')) && !(httpService.getLoading('rolePermissionsLoader'))">
        <div class="col-12 col-xl-4 col-md-6" *ngFor="let permission of permissions">
            <div class="card" style="min-height: 470px;">
                <div class="card-body">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" [id]="'permission_' + permission.id"
                            [checked]="isSelected(permission.id)" (change)="togglePermission(permission, $event)">
                        <label class="form-label" class="form-check-label" [for]="'permission_' + permission.id">
                            {{ permission.name }}
                            <i *ngIf="permission.description" class="fe fe-info text-muted ms-1"
                                style="font-size: 13px; cursor: default;" ngbTooltip="{{ permission.description }}"
                                placement="top" container="body"></i>
                        </label>
                    </div>
                    <div class="mt-3 ms-4" *ngIf="permission.sub_permissions && permission.sub_permissions.length > 0">
                        <div class="form-check" *ngFor="let subPermission of permission.sub_permissions">
                            <input class="form-check-input"
                                [type]="radioPermissionCodes.includes(subPermission.code) ? 'radio' : 'checkbox'"
                                [name]="radioPermissionCodes.includes(subPermission.code) ? 'radioGroup_' + permission.id : null"
                                [id]="'subPermission_' + subPermission.id" [checked]="isSelected(subPermission.id)"
                                (change)="onPermissionChange(permission, subPermission, $event)" />
                            <label class="form-label" class="form-check-label"
                                [for]="'subPermission_' + subPermission.id">
                                {{ subPermission.name }}
                                <i *ngIf="subPermission.description" class="fe fe-info text-muted ms-1"
                                    style="font-size: 12px; cursor: default;"
                                    ngbTooltip="{{ subPermission.description }}" placement="top" container="body"></i>
                                <small *ngIf="radioPermissionCodes.includes(subPermission.code)" class="ms-1 text-muted"
                                    style="font-size: 12px;" ngbTooltip="Only one can be selected">
                                    {{ 'OnlyOne' | translate }}
                                </small>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row"
        *ngIf="(httpService.getLoading('permissionsLoader')) || (httpService.getLoading('rolePermissionsLoader'))">
        <div class="col-12 col-xl-4 col-md-6" *ngFor="let number of [].constructor(15)">
            <ngx-skeleton-loader appearance="line" animation="progress-dark"
                [theme]="{width:'100%',height: '470px','border-radius':'0.5rem','margin-bottom':'1.5rem'}"></ngx-skeleton-loader>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-sm btn-light" (click)="activeModal.dismiss()">
        <i class="fe fe-x"></i>
        <span>{{ 'Cancel' | translate }}</span>
    </button>
    <button type="submit" class="btn btn-sm btn-custom" [disabled]="(httpService.getLoading('actionsRoleLoader'))"
        (click)="save()">
        <ng-container *ngIf="(httpService.getLoading('actionsRoleLoader'))">
            <span class="spinner-border spinner-border-sm" role="status"></span>
            <span>{{ 'Saving' | translate }} ...</span>
        </ng-container>
        <ng-container *ngIf="!(httpService.getLoading('actionsRoleLoader'))">
            <i class="fe fe-check"></i>
            <span>{{ 'Save' | translate }}</span>
        </ng-container>
    </button>
</div>